import { Button, Card, Stack, Typography } from "@mui/material";
import { convertToCamelCaseFromUnderScore, formatDate } from "../../../../common-utilities/utils"

const getStatusStyles = (status) => {
    switch (status.toLowerCase()) {
        case "approved":
            return { backgroundColor: "#4caf50", color: "white" }; // Green
        case "pending":
            return { backgroundColor: "#BDBDBD", color: "white" }; // Yellow
        case "rejected":
            return { backgroundColor: "#f44336", color: "white" }; // Red
        default:
            return { backgroundColor: "#e0e0e0", color: "black" }; // Grey (Default)
    }
};


const ApprovalDetailsCard = ({ approver, onClick, role, showButton }) => {
    const styles = getStatusStyles(approver.status);
    return <Card
        variant='outlined'
        style={{
            ...styles,
            margin: 5,
            padding: 10,
            flexWrap: "wrap"
        }}
    >
        <div style={{ borderBottom: "1px solid #fff", marginBottom: 5 }}>Role :{" "}
            {convertToCamelCaseFromUnderScore(
                approver.approverRole
            )}</div>

        {approver.comment && (
            <div style={{ marginBottom: 5 }}>Comment : {approver.comment}</div>
        )}
        {approver.approvedAt && (
            <div style={{ marginBottom: 5 }}>Updated At : {formatDate(approver.approvedAt)}</div>
        )}
        <div style={{ marginBottom: 5 }}>Status : {convertToCamelCaseFromUnderScore(approver.status)}</div>
        {showButton && role === approver.approverRole && approver.status === 'PENDING' && <Stack direction='row' spacing={2}>
            <Button variant='contained' size='small' onClick={() => onClick('Approve')}>
                Approve
            </Button>
            <Button variant='contained' color='error' size='small' onClick={() => onClick('Reject')}>
                Reject
            </Button>
        </Stack>}

    </Card>
}
export default ApprovalDetailsCard;
